<template>
  <BaseModal v-model="exitModal">
    <template #header>{{ $t('checkout.leave_checkout') }}</template>

    <div class="p-6">
      <div class="mb-2 font-semibold">
        {{ $t('checkout.leave_checkout_confirmation') }}
      </div>
      <div class="text-text text-sm">
        {{ $t('checkout.leave_checkout_continue') }}
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2" v-if="nextLink">
        <BaseButton
          class="w-full md:w-auto"
          color="accent"
          @click="exitModal = false"
        >
          {{ $t('checkout.stay_in_checkout') }}
        </BaseButton>

        <BaseButton
          class="w-full md:w-auto"
          color="primary"
          @click="handleLeave"
        >
          {{ $t('checkout.leave') }}
        </BaseButton>
      </div>
      <div v-else class="flex justify-end">
        <BaseButton
          class="w-full md:w-auto"
          color="accent"
          @click="exitModal = false"
        >
          OK
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>



<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import { onBeforeRouteLeave, useRouter } from 'vue-router';
  import { useCheckoutStore } from '@/stores/checkoutStore';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import BaseModal from '@/components/ui/BaseModal.vue';
  import { useCartStore } from '@/stores/cart';

  const exitModal = ref(false);
  const preventGuard = ref(false);

  const cart = useCartStore();

  const router = useRouter();

  const checkoutStore = useCheckoutStore();

  const nextLink = ref<string | null>(null);

  function handleLeave() {
    preventGuard.value = true;
    exitModal.value = false;
    // console.log(nextLink.value);
    if (nextLink.value) {
      router.push(nextLink.value);
    } else {
      router.push('/');
    }
  }

  onBeforeRouteLeave((to, from) => {
    if (!cart.items.length || preventGuard.value || to.query['prevent-guard'] || checkoutStore.paymentBegun || cart.isCartEmpty()) {
      return true;
    }

    preventGuard.value = true; // disabled for now, we need a specific feature for this in the future, but for now it just creates a bad user experience
    return true; // disabled for now, we need a specific feature for this in the future, but for now it just creates a bad user experience

    if (
      from.name?.toString().includes('checkout') &&
      !to.name?.toString().includes('checkout')
    ) {
      exitModal.value = true;
      nextLink.value = to.fullPath;

      return false;
    }
  });

  onMounted(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });

  function handleBeforeUnload(event: BeforeUnloadEvent) {
    if(checkoutStore.paymentBegun || cart.isCartEmpty() || preventGuard.value) return;
    event.preventDefault();
    event.returnValue = 'Du er ved at forlade checkout';
    exitModal.value = true;
    return 'Du er ved at forlade checkout';
  }
</script>
